import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import SmallBodyFont from '../../../../../Theme/Fonts/SmallBody'
import CaptionFont from '../../../../../Theme/Fonts/Caption'
import { TestID } from '../../../../../utils/PropTypesDefinitions'
import PlayerImage from '../../../../../BaseComponents/Image/Player'
import TeamImage from '../../../../../BaseComponents/Image/Team'
import LinkProps from '../../../../../Link/LinkProps'

export type TransferItemProps = {
    /**
     * bold text displayed beneath image
     */
    name: string
    /**
     * small text displayed beneath the name
     */
    caption: string
    /**
     * imageUrl of the transfer item (team or player)
     */
    imageUrl?: string
    /**
     * info about imageUrl for seo
     * */
    imageAlt?: string
    /**
     * to decide which image gets rendered team or player
     * */
    imageType?: 'TEAM' | 'PLAYER'
    /** the callback when the user presses on the forward icon
     *
     * @TJS-type function
     * */
    onPress?: () => void
    /**
     * Redirects user to the value assigned
     * */
    href?: string
} & LinkProps &
    TestID

const TransferItem: FunctionComponent<TransferItemProps> = ({
    name,
    caption,
    imageUrl,
    imageAlt,
    imageType,
    onPress,
    href,
    testID,
    webRel,
}) => (
    <Grid noExpand width="100%" minWidth={0}>
        <Touchable testID={testID} onPress={onPress} href={href} webRel={webRel}>
            <>
                <Grid noExpand horizontal centerHorizontal>
                    {imageType === 'PLAYER' ? (
                        <PlayerImage imageUrl={imageUrl} alt={imageAlt} width={24} size="M" />
                    ) : (
                        <TeamImage imageUrl={imageUrl} alt={imageAlt} width={24} size="M" />
                    )}
                </Grid>
                <SmallBodyFont numberOfLines={1} textAlign="center" color="onyx">
                    {name}
                </SmallBodyFont>
                <CaptionFont numberOfLines={1} textAlign="center" color="keshi-3">
                    {caption}
                </CaptionFont>
            </>
        </Touchable>
    </Grid>
)

export default TransferItem
